import {
    GridProps as ChakraGridProps,
    Grid as ChakraGrid,
} from '@chakra-ui/react';
import React from 'react';

export type GridProps = ChakraGridProps;

export const Grid: React.FC<GridProps> = ({
    ...props
}) => (
    <ChakraGrid {...props} />
);
